module.exports = __webpack_public_path__ + "static/media/carta_56.c4815f3d.jpg";